import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorValues from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regeneratorKeys from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _typeof from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  name: "user-member",
  mixins: [userPopMixin],
  data: function data() {
    return {
      searchForm: {
        page: 1,
        count: 20,
        status: 1,
        type: -1
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      authInfo: {},
      dialogVisible: false,
      remarkDialogVisible: false,
      currentRemarkObj: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    gotoRealName: function gotoRealName(row) {
      window.open("#/user/real-name?number=".concat(row.auth_info.idcard_number));
    },
    handlePicturePreview: function handlePicturePreview(index) {
      this.$hevueImgPreview({
        multiple: true,
        // 开启多图预览模式
        nowImgIndex: index,
        // 多图预览，默认展示第二张图片
        imgList: this.authInfo.card_img || []
      });
    },
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row;
      this.remarkDialogVisible = true;
    },
    realNameInfoDialog: function realNameInfoDialog(row) {
      this.authInfo = row.auth_info;
      this.dialogVisible = true;
    },
    cancelMember: function cancelMember(row) {
      var _this2 = this;
      this.$confirm("确认操作， 是否继续?", "取消会员", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.cancelMember({
                id: row.id
              });
            case 1:
              // 操作上报
              _this2.$operationLog.push({
                code: 'cancel',
                userId: row.user_id,
                operationType: "user",
                detailBatchNo: row.user_id
              });
              _this2.$message.success("操作成功");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))).catch(function () {});
    },
    auditMemberUser: function auditMemberUser(row, status) {
      var _this3 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var ids;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              ids = [];
              if (_typeof(row) === undefined) {
                // 批量审核通过
                status = 2;
                _this3.tableData.forEach(function (item) {
                  if (item.status == 1) {
                    ids.push(item.id);
                  }
                });
              } else {
                ids = [row.id];
              }
              _context3.n = 1;
              return _this3.$api.auditMemberUser({
                ids: ids,
                status: status
              });
            case 1:
              if (ids.length > 1) {
                // 操作上报
                _this3.$operationLog.push({
                  code: "massaudit"
                });
              } else {
                // 操作上报
                _this3.$operationLog.push({
                  code: status == 2 ? 'pass' : "reject",
                  userId: row.user_id,
                  operationType: "user",
                  detailBatchNo: row.user_id
                });
              }
              _this3.$message.success("操作成功");
              _this3.getData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))).catch(function () {});
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/user/update",
        query: {
          id: row.user_id,
          from: "user_memberlist"
        }
      });
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.getData();
    },
    getUsersTagList: function getUsersTagList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var userIds, res, _loop, key, _t, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              userIds = [];
              _this4.tableData.forEach(function (item) {
                userIds.push(item.user_id);
              });
              _context5.n = 1;
              return _this4.$api.getUsersTagList({
                top: 5,
                user_id: userIds.join(",")
              });
            case 1:
              res = _context5.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(key) {
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _this4.tableData.forEach(function (item) {
                        if (item.user_id == key) {
                          _this4.$set(item, "userTag", res.data[key]);
                        }
                      });
                    case 1:
                      return _context4.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context5.n = 4;
                break;
              }
              key = _t2.value;
              return _context5.d(_regeneratorValues(_loop(key)), 3);
            case 3:
              _context5.n = 2;
              break;
            case 4:
              return _context5.a(2);
          }
        }, _callee4);
      }))();
    },
    getUserDeviceRiskBatch: function getUserDeviceRiskBatch() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var userIds, res, _loop2, key, _t3, _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              userIds = [];
              _this5.tableData.forEach(function (item) {
                userIds.push(item.user_id);
              });
              _context7.n = 1;
              return _this5.$api.getUserDeviceRiskBatch({
                user_ids: userIds.join(",")
              });
            case 1:
              res = _context7.v;
              _loop2 = /*#__PURE__*/_regenerator().m(function _loop2(key) {
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      _this5.tableData.forEach(function (item) {
                        if (item.user_id == key) {
                          item.deviceRiskInfo = {};
                          _this5.$set(item, "deviceRiskInfo", res.data[key]);
                        }
                      });
                    case 1:
                      return _context6.a(2);
                  }
                }, _loop2);
              });
              _t3 = _regeneratorKeys(res.data);
            case 2:
              if ((_t4 = _t3()).done) {
                _context7.n = 4;
                break;
              }
              key = _t4.value;
              return _context7.d(_regeneratorValues(_loop2(key)), 3);
            case 3:
              _context7.n = 2;
              break;
            case 4:
              return _context7.a(2);
          }
        }, _callee5);
      }))();
    },
    getData: function getData(type) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var form, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (type === "search") {
                _this6.searchForm.page = 1;
              }
              form = JSON.parse(JSON.stringify(_this6.searchForm));
              if (form.start_time) {
                form.start_time = form.start_time / 1000;
              }
              if (form.end_time) {
                form.end_time = form.end_time / 1000;
              }
              _this6.tableLoading = true;
              _context8.n = 1;
              return _this6.$api.getMemberUserList(form);
            case 1:
              res = _context8.v;
              res.data.forEach(function (item) {
                if (!item.auth_info) {
                  item.auth_info = {};
                }
              });
              _this6.tableData = res.data;
              _this6.total = res.page.total;
              _this6.tableLoading = false;
              _this6.getUserScoreList(_this6.tableData);
              _this6.getUsersTagList();
              _this6.getUserDeviceRiskBatch();
              _this6.getUserListByIds(_this6.tableData, "user_id");
            case 2:
              return _context8.a(2);
          }
        }, _callee6);
      }))();
    },
    getUserScoreList: function getUserScoreList(data) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var userIds, res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              userIds = [];
              data.forEach(function (item) {
                if (item.user_id) userIds.push(item.user_id);
              });
              userIds = _toConsumableArray(new Set(userIds));
              _context9.n = 1;
              return _this7.$api.queryUserScoreById({
                userIds: userIds
              });
            case 1:
              res = _context9.v;
              if (res && res.data.length) {
                _this7.tableData.forEach(function (item) {
                  var userScore = res.data.find(function (score) {
                    return score.userId === item.user_id;
                  });
                  _this7.$set(item, 'userScore', userScore || {});
                });
              }
            case 2:
              return _context9.a(2);
          }
        }, _callee7);
      }))();
    }
  }
};